export default {
  userID: (state) => state.userID,
  auSchools: (state) => state.auSchools,
  isReadOnlyUser: (state) => state.isReadOnlyUser,
  givenName: (state) => state.givenName,
  surname: (state) => state.surname,
}
